import { Button, Divider, Form, message, Typography } from "antd";
import React, { useState } from "react";
import { InfoCircleOutlined, HomeOutlined } from "@ant-design/icons";

import AddressForm from "../components/components/account/AddressForm";
import { STEPS } from "./NewPurchaseLayout";


export default function PurchaseGuestShipping(props) {

    const {
        form,
        status = {},
        fetchShippingOptions = () => { },
        callback = () => { },
        changeAddress = () => { }
    } = props;

    const {
        email_address = ""
    } = status;

    const [loading, setLoading] = useState(false);

    const continueCheckout = () => {
        setLoading(true);
        form.validateFields()
            .then((values) => {
                setLoading(false);
                callback({
                    values,
                    address_id: values.address_id ?? null
                });
            })
            .catch((error) => {
                setLoading(false);
                const firstError = error?.errorFields?.[0];
                if (firstError?.name) {
                    form.scrollToField(firstError.name, {
                        behavior: "smooth",
                        block: "center"
                    });
                }
                message.error("Please complete the required information.");
            });
    };


    const drawAddressForm = () => {

        return (
            <>
                <Divider
                    orientation="left"
                    orientationMargin={0}
                >
                    <big>
                        <strong>Shipping Address</strong>
                    </big>
                </Divider>

                <AddressForm
                    fetchShippingOptions={(is_valid = true) => {
                        fetchShippingOptions(is_valid);
                    }}
                    type="shipping"
                    form={form}
                    disable_email_address
                    duel_name
                    data={{ email_address: email_address || "", country: "Canada" }}
                />

                <Button type="primary" size="large" block loading={loading} onClick={continueCheckout} >
                    Continue
                </Button>
            </>
        );
    };


    const drawAddressSummary = () => {

        const values = form.getFieldsValue(true);

        const addressLines = [
            values.name + " " + values.last_name,
            values.company_name,
            values.street_address,
            values.street_address_2,

            [
                values.city,
                values.province
            ]
                .filter(Boolean)
                .join(", "),

            [
                values.postal_code,
                values.country
            ]
                .filter(Boolean)
                .join(" ")

        ].filter(Boolean);


        return (
            <>
               
                <div className="shim" />
                <div className="shim" />
                <div className="checkout-row">
                    <div className="checkout-info">
                        <div className="checkout-icon">
                            <HomeOutlined />
                        </div>
                        <div style={{ minWidth: 0, flexGrow: 1 }} >
                            <Typography.Text type="secondary" style={{ display: "block", fontSize: 12 }} >
                                Shipping address
                            </Typography.Text>
                            <div style={{ lineHeight: 1.45 }}>
                                {addressLines.map((line, index) => (
                                    <div key={index}>
                                        {line}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <Button type="text" onClick={changeAddress} >
                        <small>change</small>
                    </Button>
                </div>
            </>
        );
    };


    if (status?.step !== STEPS.ADDITIONAL) {
        return drawAddressSummary();
    }


    return drawAddressForm();
}